import { UpgradeOffer } from '@pubstack/common/src/upgrade'
import { BidderRuleFormSection } from './bidderRuleSections'

/** Why a section is out of reach on this scope. Shared by the editor and the view flyout so the two never drift. */
export const BLOCKED_REASON: Record<BidderRuleFormSection, string> = {
  client_side: 'Client-side bidders belong to One, which this account does not have.',
  server_side: 'Server-side bidding needs Node or Spark, and this account has neither.',
}

/** Which offer to pitch where a section is out of reach — the one that would open it. */
export const BLOCKED_SECTION_OFFER: Record<BidderRuleFormSection, UpgradeOffer> = {
  client_side: 'one',
  server_side: 'node',
}
